import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import { connect } from "react-redux";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Layout,
  Menu,
  Icon,
  Typography,
  Avatar,
  Card,
  Button,
  Divider,
  Tooltip,
  Select,
  Affix,
  Badge,
} from "UIKit";
import styled from "styled-components";
import Loadable from "react-loadable";
import auth from "../auth";
import AppTheme from "constants/themeProvider";
import { ThemeContext } from "constants/themeContext";
import { THEME } from "constants/index";
import { SOCKET_NOTI_CONNECT, SOCKET_NOTI_CLOSE, NOTI_UPDATE } from "actions";
import DashboardProvider from "./Device/dashboardProvider";

const NotFoundPage = Loadable({
  loader: () => import(/*webpackChunkName:"page404.page"*/ "../pages/page404"),
  loading: () => null,
});
const CustomTheme = Loadable({
  loader: () =>
    import(/*webpackChunkName:"customTheme.comp"*/ "constants/customTheme"),
  loading: () => null,
});
const Project = Loadable({
  loader: () => import(/*webpackChunkName:"project.page"*/ "./Project/project"),
  loading: () => null,
});
const Drawing_Conn = Loadable({
  loader: () =>
    import(/*webpackChunkName:"drawingConn.page"*/ "./Device/drawingConn"),
  loading: () => null,
});
const Graph_Conn = Loadable({
  loader: () =>
    import(/*webpackChunkName:"graphConn.page"*/ "./Device/graphConn"),
  loading: () => null,
});
const Map_Conn = Loadable({
  loader: () => import(/*webpackChunkName:"mapConn.page"*/ "./Device/mapConn"),
  loading: () => null,
});
const VR360_Conn = Loadable({
  loader: () =>
    import(/*webpackChunkName:"vr360Conn.page"*/ "./Device/vr360Conn"),
  loading: () => null,
});
const Mixed = Loadable({
  loader: () => import(/*webpackChunkName:"mixed.page"*/ "./Mixed/mixed"),
  loading: () => null,
});
const Log = Loadable({
  loader: () => import(/*webpackChunkName:"log.page"*/ "./Log/log"),
  loading: () => null,
});
const Graph_log = Loadable({
  loader: () => import(/*webpackChunkName:"logGraph.page"*/ "./Log/logGraph"),
  loading: () => null,
});
const Registration = Loadable({
  loader: () =>
    import(/*webpackChunkName:"registration.page"*/ "./User/registration"),
  loading: () => null,
});
const Branch = Loadable({
  loader: () => import(/*webpackChunkName:"branch.page"*/ "./User/branch"),
  loading: () => null,
});
const DragDropContext = Loadable({
  loader: () =>
    import(
      /*webpackChunkName:"template_excel.page"*/ "./Report/template_excel"
    ),
  loading: () => null,
});
const Report = Loadable({
  loader: () => import(/*webpackChunkName:"report.page"*/ "./Report/report"),
  loading: () => null,
});
const Device = Loadable({
  loader: () => import(/*webpackChunkName:"device.page"*/ "./Device/device"),
  loading: () => null,
});
const Alarm = Loadable({
  loader: () => import(/*webpackChunkName:"alarm.page"*/ "./Alarm"),
  loading: () => null,
});
const AI = Loadable({
  loader: () => import(/*webpackChunkName:"ai.page"*/ "./AI/ai"),
  loading: () => null,
});
// const BpmnBoard = Loadable({
//   loader: () =>
//     import(
//       /*webpackChunkName:"bpmnBoard.page"*/ "./bpmn-workflow-js/BpmnBoard/index"
//     ),
//   loading: () => null,
// });
// const ProcessWorkflow = Loadable({
//   loader: () =>
//     import(
//       /*webpackChunkName:"processWorkflow.page"*/ "./bpmn-workflow-js/ProcessWorkflow/index"
//     ),
//   loading: () => null,
// });
// const Dashboard = Loadable({
//   loader: () =>
//     import(
//       /*webpackChunkName:"dashboard.page"*/ "./bpmn-workflow-js/Dashboard/index"
//     ),
//   loading: () => null,
// });
const Permission = Loadable({
  loader: () =>
    import(/*webpackChunkName:"permission.page"*/ "./User/permission"),
  loading: () => null,
});
const UserInfo = Loadable({
  loader: () => import(/*webpackChunkName:"userInfo.page"*/ "./User/userInfo"),
  loading: () => null,
});

const { Text } = Typography;
const { Header, Content } = Layout;
const { SubMenu } = Menu;
const { Option } = Select;

String.prototype.trunc =
  String.prototype.trunc ||
  function(n) {
    return this.length > n ? this.substr(0, n - 1) + "..." : this.substr(0);
  };

String.prototype.dateFormat =
  String.prototype.dateFormat ||
  function() {
    try {
      let year = this.split("-")[0];
      let month = this.split("-")[1];
      let day = this.split("-")[2];
      if (day.includes("T")) {
        day = day.split("T")[0];
      }
      return day + "/" + month + "/" + year;
    } catch (err) {
      return this;
    }
  };

String.prototype.dateTimeFormat =
  String.prototype.dateTimeFormat ||
  function() {
    try {
      let date = this.split("T")[0];
      let time = this.split("T")[1]
        .split("Z")[0]
        .split(".")[0];
      let year = date.split("-")[0];
      let month = date.split("-")[1];
      let day = date.split("-")[2];
      return day + "/" + month + "/" + year + " " + time;
    } catch (err) {
      return this;
    }
  };

String.prototype.timeFormat =
  String.prototype.timeFormat ||
  function() {
    try {
      let data = this.split("+")[0];
      let date = data.split("T")[0];
      let time = data.split("T")[1];
      let year = date.split("-")[0];
      let month = date.split("-")[1];
      let day = date.split("-")[2];
      return day + "/" + month + "/" + year + " " + time;
    } catch (err) {
      return this;
    }
  };

Number.prototype.digit =
  Number.prototype.digit ||
  function(n) {
    if (n === 0) {
      return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      let x = parseFloat(this)
        .toFixed(n)
        .split(".");
      return x[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + x[1];
    }
  };

//------------------- find min max in array object --------------
Array.prototype.hasMin = function(attrib) {
  return this.reduce(function(prev, curr) {
    return prev[attrib] < curr[attrib] ? prev : curr;
  });
};

Array.prototype.hasMax = function(attrib) {
  return this.reduce(function(prev, curr) {
    return prev[attrib] > curr[attrib] ? prev : curr;
  });
};
//---------------------------------------------------------------

let hostname = `${window.location.protocol}//${window.location.host}/restapi`;
if (window.DEBUG) {
  hostname = `${window.EndPoint}/restapi`;
}

class MainPage extends React.Component {
  constructor() {
    super();
    this.state = {
      user: undefined,
      permission: [],
      current: undefined,
      version: [],
      document_list: [],
      language_list: [],
      language: {},
      UIKey: undefined,
      visible_custom: false,
      noti_count: 0,
    };
    // this.notification = setInterval(this.getNotification,5000)
  }
  componentWillReceiveProps(props) {
    const { alertNotificationReducer, language } = props;
    this.setState({
      noti_count:
        (alertNotificationReducer?.noti_count?.tag_alert?.count ?? 0) +
        (alertNotificationReducer?.noti_count?.system_alert?.count ?? 0),
    });
  }
  getNotification = () => {
    $.ajax({
      async: false,
      crossDomain: true,
      url: hostname + "/alerts/unreadcount/",
      type: "GET",
      dataType: "json",
      contentType: "application/json",
      headers: {
        authorization: "Token " + auth.getToken(),
        accept: "application/json;odata=verbose",
      },
      success: function(result) {
        // this.props.SOCKET_NOTI_CONNECT(this.updateNotiValue);
        this.props.NOTI_UPDATE(result);
        this.setState({
          noti_count: result.tag_alert.count + result.system_alert.count,
        });
      }.bind(this),
      error: function(response) {},
    });
  };
  direct_path = (user, permission) => {
    if (!user) {
      this.props.history.push("/login");
      return;
    }
    const { location } = this.props;
    let current = location.pathname;
    if (current === "/") {
      if (permission.includes("menu.present.dashboard.view")) {
        current = "/dashboard";
      } else {
        if (permission.length) {
          let codename = permission[0];
          switch (codename) {
            case "menu.present.graph.view":
              current = "/present/graph";
              break;
            case "menu.log.graph.view":
              current = "/log/graph";
              break;
            // case "menu.workflow.view":
            //   current = "/workflow/dashboard";
            //   break;
            case "menu.workflow.view":
              current = "/workflow";
              break;
            default:
              let separate_code = codename.split(".");
              current = "/" + separate_code[separate_code.length - 2];
          }
        }
      }
      this.props.history.push(current);
    }
    return current;
  };
  componentWillMount() {
    let user = auth.getUser();
    let permission = user?.permission.map((m) => m.codename) ?? [];

    let current = this.direct_path(user, permission);

    this.setState({
      user: user,
      permission: permission,
      current,
    });
    if (user) {
      this.get_data(user.language);
    }
    this.getNotification();
    this.props.SOCKET_NOTI_CONNECT(this.updateNotiValue);
  }
  updateNotiValue = (e) => {
    let data = JSON.parse(e.data);
    let message = JSON.parse(data["message"]);
    let value = JSON.parse(message["value"]);
    this.getNotification();
    if (value.hasOwnProperty("value")) {
      switch (value.priority.toLowerCase()) {
        case "info":
          NotificationManager.info(value.value, value.type);
          break;
        case "success":
          NotificationManager.success(value.value, value.type);
          break;
        case "warning":
          NotificationManager.warning(value.value, value.type);
          break;
        case "error":
          NotificationManager.error(value.value, value.type);
          break;
        default:
          NotificationManager.info(value.value, value.type);
          break;
      }
    } else {
      switch (value.priority.toLowerCase()) {
        case "low":
          NotificationManager.warning(value.message, "Severity: Low");
          break;
        // case "success":
        //   NotificationManager.success(value.message, 'Severity: Success');
        //   break;
        case "medium":
          NotificationManager.error(value.message, "Severity: Medium");
          break;
        case "high":
          NotificationManager.error(value.message, "Severity: High");
          break;
        default:
          NotificationManager.info(value.message, "Severity: info");
          break;
      }
    }
  };
  componentWillUnmount() {
    this.props.SOCKET_NOTI_CLOSE();
    // clearInterval(this.notification)
  }
  componentDidMount() {
    let width = $(window).width() - 200;
    $(".ant-menu-horizontal").width(width);
    $(".ant-menu-horizontal").css("max-width", width);
  }
  componentDidUpdate(prevProps, prevState) {
    try {
      const { location } = this.props;
      const { user, permission } = this.state;
      if (prevProps.location !== location) {
        let current = this.direct_path(user, permission);
        this.setState({ current });
      }
    } catch (err) {}
  }
  logOut = () => {
    auth.logout();
  };
  menuAdmin = () => {
    let win = window.open(hostname + "/admin/", "_blank");
    win.focus();
  };
  handleClick = (e) => {
    this.setState({ current: e.key });
  };
  async onSave_user_language(value) {
    let results = {};
    try {
      results.user_language = await axios.post(
        `${hostname}/tag/user_language/`,
        { language: value },
        { headers: { authorization: `Token ${auth.getToken()}` } }
      );
      results.dictionary = await this.onChangeLanguage(value);
      this.setState({
        language: results.dictionary,
        UIKey: value,
      });
    } catch (error) {
      console.log(`user language : ${error.message}`);
    }
  }
  async onChangeLanguage(value) {
    let results = {};
    try {
      results = await axios.get(`${hostname}/tag/ui_elements3/?lang=${value}`, {
        headers: { authorization: `Token ${auth.getToken()}` },
      });
      return results.data;
    } catch (error) {
      console.log(`language : ${error.message}`);
      return results;
    }
  }
  async selectTheme(value) {
    let results = {};
    try {
      results.theme = await axios.post(
        `${hostname}/tag/user_theme/`,
        { theme: value },
        { headers: { authorization: `Token ${auth.getToken()}` } }
      );
    } catch (error) {
      console.log(`select theme : ${error.message}`);
    }
  }
  updateVisible = (value) => {
    this.setState({ visible_custom: value });
  };
  async get_data(value) {
    let results = {};
    try {
      results.version = await axios.get(`${hostname}/version/`, {
        headers: { authorization: `Token ${auth.getToken()}` },
      });
      results.documents = await axios.get(`${hostname}/tag/documents/`, {
        headers: { authorization: `Token ${auth.getToken()}` },
      });
      results.languages = await axios.get(`${hostname}/tag/get_languages/`, {
        headers: { authorization: `Token ${auth.getToken()}` },
      });
      results.dictionary = await this.onChangeLanguage(value);
      this.setState({
        version: results.version.data.version,
        document_list: results.documents.data.results.filter(
          (f) => f.is_use === true
        ),
        language_list: results.languages.data,
        language: results.dictionary,
        UIKey: value,
      });
    } catch (error) {
      console.log(`data : ${error.message}`);
    }
  }
  async updateVersion() {
    let results = {};
    try {
      results.systemupdate = await axios.post(
        `${hostname}/task_manager/systemupdate/`,
        { headers: { authorization: `Token ${auth.getToken()}` } }
      );
    } catch (error) {
      console.log(`system update : ${error.message}`);
    }
  }
  render() {
    const {
      current,
      version,
      document_list,
      language_list,
      language,
      UIKey,
      visible_custom,
    } = this.state;
    let dictionary = language || {};
    const {
      Consumer: {
        _currentValue: { theme },
      },
    } = ThemeContext;
    let content = [];
    for (let doc of document_list) {
      content.push(
        <Button
          type="primary"
          icon="download"
          size="small"
          href={doc.file}
          target="_blank"
          style={{ textAlign: "left", marginTop: 6 }}
          block
          key={"vs_key_" + doc.id}
        >
          {doc.name}
        </Button>
      );
    }
    // let coreProps = {
    //   urls: {
    //     add_bpmn: "/workflow/add_bpmn",
    //     edit_bpmn: "/workflow/edit_bpmn",
    //     view_process: "/workflow/view_process",
    //     dashboard: "/workflow/dashboard",
    //   },
    //   engine_url: "http://103.212.181.125:8000/flow-api",
    //   user_token: `Token ${auth.getToken()}`,
    // };
    return (
      <AppTheme>
        <ThemeContext.Consumer>
          {(item) => (
            <Layout>
              <NotificationContainer />
              {!item.hideTop ? (
                <Header style={{ padding: 0 }}>
                  <Avatar
                    shape="square"
                    className="logo font-Menu"
                    style={{ margin: 12 }}
                  >
                    <Tooltip
                      title={
                        <div
                          style={{ minWidth: 176, marginTop: 5 }}
                          id="version_pn"
                        >
                          {version.length ? (
                            <div>
                              <Text style={{ color: "white" }} underline>
                                Version
                              </Text>
                              &nbsp;:&nbsp;{version[0]}
                              <Button
                                type="primary"
                                icon="sync"
                                size="small"
                                style={{ textAlign: "left", marginTop: 6 }}
                                block
                                onClick={() => {
                                  this.updateVersion();
                                }}
                              >
                                Update Version
                              </Button>
                            </div>
                          ) : null}
                          {language_list.length ? (
                            <div>
                              <Divider
                                style={{ marginTop: 6, marginBottom: 6 }}
                              />
                              <Text style={{ color: "white" }} underline>
                                Language
                              </Text>
                              <Select
                                onChange={(e) => {
                                  this.onSave_user_language(e);
                                }}
                                size="small"
                                style={{
                                  width: "100%",
                                  marginTop: 6,
                                }}
                                value={UIKey}
                                // open={true}
                              >
                                {language_list.map((d) => (
                                  <Option key={d.key} value={d.key}>
                                    {d.name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          ) : null}
                          {document_list.length ? (
                            <div>
                              <Divider
                                style={{ marginTop: 6, marginBottom: 6 }}
                              />
                              <Text style={{ color: "white" }} underline>
                                Document
                              </Text>
                              {content}
                            </div>
                          ) : null}
                          {THEME.length ? (
                            <div>
                              <Divider
                                style={{ marginTop: 6, marginBottom: 6 }}
                              />
                              <Text style={{ color: "white" }} underline>
                                Theme
                              </Text>
                              <Select
                                onChange={(e) => {
                                  item.setTheme(() => {
                                    let obj = THEME.find((f) => f.NAME === e);
                                    if (e === "Custom") {
                                      obj = item.theme;
                                    }
                                    return obj;
                                  });
                                  if (e !== "Custom") {
                                    this.selectTheme(e);
                                  }
                                }}
                                onSelect={(e) => {
                                  if (e === "Custom") {
                                    this.setState({ visible_custom: true });
                                  }
                                }}
                                size="small"
                                style={{
                                  width: "100%",
                                  marginBottom: 2,
                                  marginTop: 6,
                                }}
                                defaultValue={item.theme.NAME}
                                // open={true}
                              >
                                {THEME.map((d) => (
                                  <Option key={d.NAME} value={d.NAME}>
                                    {d.NAME}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          ) : null}
                          <CustomTheme
                            visible={visible_custom}
                            updateVisible={this.updateVisible}
                          />
                        </div>
                      }
                      placement="bottom"
                      // visible={true}
                    >
                      SCADA TH
                    </Tooltip>
                  </Avatar>
                  <Menu
                    theme="light"
                    mode="horizontal"
                    onClick={this.handleClick}
                    selectedKeys={[current]}
                    // openKeys={["5555"]}
                  >
                    {item.permission.includes("menu.project.view") ? (
                      <Menu.Item key="/project">
                        <Icon type="project" />
                        <span className="font-Menu">
                          {dictionary.project || "Project"}
                        </span>
                        <Link to="/project" />
                      </Menu.Item>
                    ) : null}
                    {item.permission.includes("menu.device.view") ? (
                      <Menu.Item key="/device">
                        <Icon type="appstore" />
                        <span className="font-Menu">
                          {dictionary.device || "Device"}
                        </span>
                        <Link to="/device" />
                      </Menu.Item>
                    ) : null}
                    {item.permission.filter((f) => f.startsWith("menu.present"))
                      .length ? (
                      <SubMenu
                        title={
                          <span className="font-Menu">
                            <Icon type="dashboard" />
                            {dictionary.present || "Present"}
                          </span>
                        }
                      >
                        {item.permission.includes(
                          "menu.present.dashboard.view"
                        ) ? (
                          <Menu.Item key="/dashboard">
                            <Icon type="dashboard" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.dashboard || "Dashboard"}
                            </span>
                            <Link to="/dashboard" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.present.graph.view") ? (
                          <Menu.Item key="/present/graph">
                            <Icon type="line-chart" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.graph || "Graph"}
                            </span>
                            <Link to="/present/graph" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.present.map.view") ? (
                          <Menu.Item key="/map">
                            <Icon
                              type="environment"
                              className="icon-Menu-sub"
                            />
                            <span className="font-Menu-sub">
                              {dictionary.map || "Map"}
                            </span>
                            <Link to="/map" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.present.vr360.view") ? (
                          <Menu.Item key="/vr360">
                            <Icon type="build" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.vr360 || "VR360"}
                            </span>
                            <Link to="/vr360" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.present.mixed.view") ? (
                          <Menu.Item key="/mixed">
                            <Icon type="read" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.mixed || "Mixed"}
                            </span>
                            <Link to="/mixed" />
                          </Menu.Item>
                        ) : null}
                      </SubMenu>
                    ) : null}
                    {item.permission.filter((f) => f.startsWith("menu.log"))
                      .length ? (
                      <SubMenu
                        title={
                          <span className="font-Menu">
                            <Icon type="database" />
                            {dictionary.log || "Log"}
                          </span>
                        }
                        // key="5555"
                      >
                        {item.permission.includes("menu.log.log.view") ? (
                          <Menu.Item key="/log">
                            <Icon type="database" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.log || "Log"}
                            </span>
                            <Link to="/log" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.log.graph.view") ? (
                          <Menu.Item key="/log/graph">
                            <Icon type="line-chart" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.graph || "Graph"}
                            </span>
                            <Link to="/log/graph" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.log.report.view") ? (
                          <Menu.Item key="/report">
                            <Icon type="file-text" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.report || "Report"}
                            </span>
                            <Link to="/report" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes(
                          "menu.log.template_excel.view"
                        ) ? (
                          <Menu.Item key="/template_excel">
                            <Icon type="file-text" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.template_excel || "Template Excel"}
                            </span>
                            <Link to="/template_excel" />
                          </Menu.Item>
                        ) : null}
                      </SubMenu>
                    ) : null}
                    {item.permission.includes("menu.alarm.view") ? (
                      <Menu.Item key="/alarm">
                        <Icon type="alert" />
                        <span className="font-Menu">
                          {dictionary.alarm || "Alarm"}
                        </span>
                        <Badge
                          count={this.state.noti_count}
                          overflowCount={999999999}
                          style={{ marginLeft: "8px" }}
                        ></Badge>
                        <Link to="/alarm" />
                      </Menu.Item>
                    ) : null}
                    {item.permission.includes("menu.ai.view") ? (
                      <Menu.Item key="/ai">
                        <Icon type="robot" />
                        <span className="font-Menu">
                          {dictionary.ai || "AI"}
                        </span>
                        <Link to="/ai" />
                      </Menu.Item>
                    ) : null}
                    {item.permission.includes("menu.workflow.view") ? (
                      // <Menu.Item key="/workflow/dashboard">
                      //   <Icon type="apartment" />
                      //   <span className="font-Menu">
                      //     {dictionary.workflow || "Workflow"}
                      //   </span>
                      //   <Link to="/workflow/dashboard" />
                      // </Menu.Item>
                      <Menu.Item key="/workflow">
                        <Icon type="apartment" />
                        <span className="font-Menu">
                          {dictionary.workflow || "Workflow"}
                        </span>
                        <a
                          onClick={() => {
                            let win = window.open(
                              `${window.EndPoint2}`,
                              "_blank"
                            );
                            win.focus();
                          }}
                        />
                      </Menu.Item>
                    ) : null}
                    {item.permission.filter((f) => f.startsWith("menu.admin"))
                      .length ? (
                      <SubMenu
                        title={
                          <span className="font-Menu">
                            <Icon type="user" />
                            {dictionary.admin || "Admin"}
                          </span>
                        }
                      >
                        {item.permission.includes("menu.admin.admin.view") ? (
                          <Menu.Item key="/admin">
                            <Icon type="user" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.admin || "Admin"}
                            </span>
                            <a onClick={this.menuAdmin} />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes(
                          "menu.admin.registration.view"
                        ) ? (
                          <Menu.Item key="/registration">
                            <Icon type="user-add" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.registration || "Registration"}
                            </span>
                            <Link to="/registration" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes("menu.admin.branch.view") ? (
                          <Menu.Item key="/branch">
                            <Icon type="home" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.branch || "Branch"}
                            </span>
                            <Link to="/branch" />
                          </Menu.Item>
                        ) : null}
                        {item.permission.includes(
                          "menu.admin.permission.view"
                        ) ? (
                          <Menu.Item key="/permission">
                            <Icon type="idcard" className="icon-Menu-sub" />
                            <span className="font-Menu-sub">
                              {dictionary.permission || "Permission"}
                            </span>
                            <Link to="/permission" />
                          </Menu.Item>
                        ) : null}
                      </SubMenu>
                    ) : null}
                    <SubMenu
                      title={
                        <Tooltip
                          title={item.userProfile?.first_name}
                          placement="right"
                        >
                          <Avatar
                            size={32}
                            style={{
                              color: item.theme.PROPERTY.COLOR.INFO,
                              backgroundColor:
                                item.theme.PROPERTY.BACKGROUND.SECONDARY,
                              textTransform: "uppercase",
                              marginTop: -2,
                              fontWeight: "bold",
                            }}
                          >
                            {item.userProfile?.first_name?.substring(0, 1)}
                          </Avatar>
                        </Tooltip>
                      }
                    >
                      <Menu.Item key="/userInfo">
                        <Icon type="idcard" className="icon-Menu-sub" />
                        <span className="font-Menu-sub">User Profile</span>
                        <Link to="/userInfo" />
                      </Menu.Item>
                      <Menu.Item key="/logout">
                        <Icon type="logout" className="icon-Menu-sub" />
                        <span className="font-Menu-sub">
                          {dictionary.logout || "Logout"}
                        </span>
                        <a onClick={this.logOut} />
                      </Menu.Item>
                    </SubMenu>
                  </Menu>
                </Header>
              ) : null}
              <Content
                id="main_page"
                style={{
                  height: item.hideTop
                    ? window.innerHeight
                    : window.innerHeight - 56,
                }}
              >
                <DashboardProvider>
                  <Card
                    style={{
                      border: 0,
                      borderRadius: 0,
                      height: "auto",
                      minHeight: "100%",
                    }}
                    id="card_main_page"
                  >
                    <Affix
                      style={{
                        position: "absolute",
                        top: 0,
                        left: window.innerWidth / 2 - 16,
                        zIndex: 3,
                      }}
                    >
                      <Button
                        type="primary"
                        icon={item.hideTop ? "down" : "up"}
                        onClick={() => {
                          item.setHideTop(!item.hideTop);
                        }}
                        size="small"
                        style={{ borderRadius: "0 0 11px 11px" }}
                      />
                    </Affix>
                    <Switch>
                      {item.permission.includes("menu.project.view") ? (
                        <Route
                          path="/project"
                          render={(props) => (
                            <Project {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes(
                        "menu.present.dashboard.view"
                      ) ? (
                        <Route
                          path="/dashboard"
                          render={(props) => (
                            <Drawing_Conn {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.present.graph.view") ? (
                        <Route
                          path="/present/graph"
                          render={(props) => (
                            <Graph_Conn {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.present.map.view") ? (
                        <Route
                          path="/map"
                          render={(props) => (
                            <Map_Conn {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.present.vr360.view") ? (
                        <Route
                          path="/vr360"
                          render={(props) => (
                            <VR360_Conn {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.present.mixed.view") ? (
                        <Route
                          path="/mixed"
                          render={(props) => (
                            <Mixed {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.log.log.view") ? (
                        <Route
                          path="/log"
                          render={(props) => (
                            <Log {...props} language={language} UIKey={UIKey} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.log.graph.view") ? (
                        <Route
                          path="/log/graph"
                          render={(props) => (
                            <Graph_log
                              {...props}
                              language={language}
                              UIKey={UIKey}
                            />
                          )}
                        />
                      ) : null}
                      {item.permission.includes(
                        "menu.admin.registration.view"
                      ) ? (
                        <Route
                          path="/registration"
                          render={(props) => (
                            <Registration {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.admin.branch.view") ? (
                        <Route
                          path="/branch"
                          render={(props) => (
                            <Branch {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes(
                        "menu.log.template_excel.view"
                      ) ? (
                        <Route
                          path="/template_excel"
                          render={(props) => (
                            <DragDropContext
                              {...props}
                              language={language}
                              UIKey={UIKey}
                            />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.log.report.view") ? (
                        <Route
                          path="/report"
                          render={(props) => (
                            <Report {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.device.view") ? (
                        <Route
                          path="/device"
                          render={(props) => (
                            <Device {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.alarm.view") ? (
                        <Route
                          path="/alarm"
                          render={(props) => (
                            <Alarm {...props} language={language} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.ai.view") ? (
                        <Route
                          path="/ai"
                          render={(props) => (
                            <AI {...props} language={language} UIKey={UIKey} />
                          )}
                        />
                      ) : null}
                      {/* {item.permission.includes("menu.workflow.edit") ? (
                        <Route
                          path={coreProps.urls.add_bpmn}
                          render={(props) => (
                            <BpmnBoard {...props} coreProps={coreProps} />
                          )}
                        />
                      ) : null}
                      {item.permission.includes("menu.workflow.edit") ? (
                        <Route
                          path={`${coreProps.urls.edit_bpmn}/:workflow_id`}
                          render={(props) => (
                            <BpmnBoard {...props} coreProps={coreProps} />
                          )}
                        />
                      ) : null} */}
                      {/* {item.permission.includes("menu.workflow.view") ? (
                        <Route
                          path={`${coreProps.urls.view_process}/:workflow_id`}
                          render={(props) => (
                            <ProcessWorkflow {...props} coreProps={coreProps} />
                          )}
                        />
                      ) : null} */}
                      {/* {item.permission.includes("menu.workflow.view") ? (
                        <Route
                          path={coreProps.urls.dashboard}
                          render={(props) => (
                            <Dashboard {...props} coreProps={coreProps} />
                          )}
                        />
                      ) : null} */}
                      {item.permission.includes(
                        "menu.admin.permission.view"
                      ) ? (
                        <Route
                          path="/permission"
                          render={(props) => (
                            <Permission {...props} language={language} />
                          )}
                        />
                      ) : null}
                      <Route
                        path="/userInfo"
                        render={(props) => (
                          <UserInfo {...props} language={language} />
                        )}
                      />
                      <Route component={NotFoundPage} />
                    </Switch>
                  </Card>
                </DashboardProvider>
              </Content>
            </Layout>
          )}
        </ThemeContext.Consumer>
      </AppTheme>
    );
  }
}

const mapStateToProps = (state) => {
  const { socketNotiReducer, alertNotificationReducer } = state;
  return { socketNotiReducer, alertNotificationReducer };
};

const mapDispatchtoProps = (dispatch) => {
  return {
    SOCKET_NOTI_CONNECT: (updateValue) => {
      dispatch({ type: SOCKET_NOTI_CONNECT, payload: updateValue });
    },
    SOCKET_NOTI_CLOSE: () => {
      dispatch({ type: SOCKET_NOTI_CLOSE });
    },
    NOTI_UPDATE: (count) => {
      dispatch({ type: NOTI_UPDATE, payload: count });
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchtoProps
)(MainPage);
//export default MainPage;

let resizeWindows = function() {
  let width = $(window).width() - 200;
  $(".ant-menu-horizontal").width(width);
  $(".ant-menu-horizontal").css("max-width", width);

  // let height = $(window).height() - 56;
  // $(".ant-layout-content").attr("style", "height: " + height + "px !important");
};
$(function() {
  $(window).resize(resizeWindows);
});
